export default {"src":"/_next/static/media/gates.2975884d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};